import React, { useEffect, useRef, useState } from 'react';
import propTypes from 'prop-types';
import { BackgroundMedia } from '_ui-core-js/React/components/BackgroundMedia.jsx';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { fitToScreen } from '_ui-core-js/utilities/fitToScreen.js';
import { constants } from '../../constants';

export function LoadingScreen(props) {
    
    const { onLoadingCompletion, loadingConditionsComplete, videoUrl } = props;
    const { MEDIA_TYPES: { VIDEO } } = constants;
    const [ loadingAnimationFinished, setLoadingAnimationFinished] = useState(false);
    const rootElRef = useRef();
    const fitToScreenRef = useRef(); 
    const block = 'c-loading-screen'
    const videoConfig = {
        onEnded:()=> { setLoadingAnimationFinished(true) },
        loop: false
    }

    useEffect(() => {
        fitToScreenRef.current = fitToScreen(rootElRef.current, [document.querySelector('.header')])

        fitToScreenRef.current.init();
        return () => {
            fitToScreenRef.current.destroy();
        }
    }, []);

    useEffect(() => {
        if (loadingConditionsComplete && loadingAnimationFinished) {
            onLoadingCompletion();
        }
    }, [loadingConditionsComplete, loadingAnimationFinished]);

    return (
        <div className={block} ref={rootElRef}>
            <CssAnimation
                enter={{ name: 'fade-in', duration: 2 }}
                triggerEnter={true}
                renderView={!!videoUrl}
            >
                <div>
                    <BackgroundMedia
                        mediaType={VIDEO}
                        mediaUrl={videoUrl}
                        videoConfig={videoConfig}
                    />
                </div>
            </CssAnimation>
        </div>
    )
}

LoadingScreen.propTypes = {
    onLoadingCompletion: propTypes.func,
    loadingConditionsComplete: propTypes.bool,
    videoUrl: propTypes.string
}; 